import type { OrchidDriveFile } from "contexts/orchid-drive/types";
import type { PatientNoteWithSecureData } from "services/queryPatientNotes";
import { ReactNode, createContext, useContext } from "react";

type Props = {
  noteByAttachmentId: Record<string, PatientNoteWithSecureData>;
  children: ReactNode;
};
type Context = {
  noteByAttachmentId: Record<
    OrchidDriveFile["fileDataId"],
    PatientNoteWithSecureData | undefined
  >;
};

/**
 * context used to register ActionItems open / close state
 * sample use case: only one pop up will be allowed to render on the screen
 */
const NoteByAttachmentIdContext = createContext<Context>({
  noteByAttachmentId: {},
});

export const NoteByAttachmentIdContextProvider = ({
  noteByAttachmentId,
  children,
}: Props) => {
  return (
    <NoteByAttachmentIdContext.Provider
      value={{
        noteByAttachmentId,
      }}
    >
      {children}
    </NoteByAttachmentIdContext.Provider>
  );
};

export const useNoteByAttachmentIdContext = () =>
  useContext(NoteByAttachmentIdContext);
